import Vue from "vue";

// A wait shorter than this is over before anyone would notice the bar, so showing it would only flicker.
export const SHOW_DELAY_MS = 200;

/** Read by NavigationProgressBar. */
export const navigationProgress = Vue.observable({ visible: false });

let pending = 0;
let showTimer: ReturnType<typeof setTimeout> | undefined;

/**
 * Shows the top-of-page progress bar while a navigation waits on `work`, once the wait has
 * outlasted SHOW_DELAY_MS. Overlapping waits share one bar, which hides when the last settles.
 *
 * Tracked per promise rather than per navigation: Vue Router 3 runs no afterEach for an aborted
 * navigation (an unsaved-changes prompt answered "stay"), so a bar keyed to navigations could stick.
 * A promise always settles.
 */
export function trackNavigationWait<T>(work: Promise<T>): Promise<T> {
    pending++;
    if (pending === 1) {
        showTimer = setTimeout(() => {
            navigationProgress.visible = true;
        }, SHOW_DELAY_MS);
    }

    const settle = () => {
        pending--;
        if (pending > 0) return;

        clearTimeout(showTimer);
        navigationProgress.visible = false;
    };
    work.then(settle, settle);

    return work;
}
